export default {
  dbu_user_data_center_title: 'Your DataBrain MBTI',
  dbu_user_data_center_subtitle: 'Explore your quarterly DataBrain journey and personalized data profile',
};
